import {useEffect, useRef} from "react";
import {borderRadius, colors, fontsSize, plainColors} from "./UIElements/Elements";
import OrderItem from "./OrderItem";

const OrderSideBar = ({orderItems, orderItemsToAdd, setOrderItemsToAdd, setActiveOrderItem, orderedSum, toAddSum}) => {
    const listRef = useRef(null);
    const lastItemRef = useRef(null);

    useEffect(() => {
        if (listRef.current) {
            listRef.current.scrollTop = listRef.current.scrollHeight;
        }
    }, [orderItemsToAdd]);

    const handleSelectItem = (id) => {
        setOrderItemsToAdd(prevItems =>
            prevItems.map(item => ({
                ...item,
                selected: item.id === id
            }))
        );
    };

    const increaseSelectedQuantity = () => {
        setOrderItemsToAdd(prevItems =>
            prevItems.map(item =>
                item.selected ? {...item, quantity: Number(item.quantity) + 1} : item
            )
        );
    };

    const decreaseSelectedQuantity = () => {
        setOrderItemsToAdd(prevItems => {
            let updatedItems = prevItems
                .map(item =>
                    item.selected ? {...item, quantity: item.quantity - 1} : item
                )
                .filter(item => item.quantity > 0);


            if (updatedItems.length > 0) {
                updatedItems[updatedItems.length - 1] = {
                    ...updatedItems[updatedItems.length - 1],
                    selected: true
                };
            }

            return updatedItems;
        });
    };

    const removeSelectedItem = () => {
        setOrderItemsToAdd(prevItems => {
            let updatedItems = prevItems.filter(item => !item.selected);

            if (updatedItems.length > 0) {
                updatedItems[updatedItems.length - 1] = {
                    ...updatedItems[updatedItems.length - 1],
                    selected: true
                };
            }

            return updatedItems;
        });
    };


    return (
        <div
            className="fixed w-[27%] h-[92vh] top-[8vh] left-0 flex flex-col justify-center items-center pl-[2vh] overflow-hidden max-lg:w-[100vw] max-lg:h-[35vh] max-lg:top-[58vh] max-lg:pl-0">
            <div className={`relative w-[100%] h-[100%] mt-[0vh] ${borderRadius.large}`}>
                <div
                    ref={listRef}
                    className={`relative flex-col items-center justify-center h-[70vh] w-[100%] overflow-y-auto p-[1vh] custom-scrollbar border-blue-100 border-[1px] ${borderRadius.medium} max-lg:h-[18vh] max-lg:p-[0.5vh]`}
                >
                    {orderItems.map((item) => (
                        <OrderItem
                            key={item.id}
                            productName={item.product_name}
                            productPrice={item.product_price}
                            quantity={item.quantity}
                            createdAt={item.created_at}
                            isNew={false}
                            onSelect={() => {
                            }}
                            onDoubleClick={() => {
                            }}
                        />
                    ))}
                    {orderItemsToAdd.map((item, index) => (
                        <OrderItem
                            key={item.id}
                            id={item.id}
                            productId={item.product_id}
                            productName={item.product_name}
                            productPrice={item.product_price}
                            quantity={item.quantity}
                            isNew={true}
                            isSelected={item.selected}
                            onSelect={handleSelectItem}
                            onDoubleClick={() => setActiveOrderItem(item)}
                            ref={index === orderItemsToAdd.length - 1 ? lastItemRef : null}
                            comment={item.comment}
                        />
                    ))}
                </div>
                <div
                    className={`w-[100%] h-[18vh] ${borderRadius.medium} p-[1vh] mt-[1vh] flex justify-start items-center flex-wrap max-lg:h-[15vh]`}>
                    <div onClick={removeSelectedItem}
                         className={`w-[48%] h-[48%] ${colors.primary} flex justify-center items-center ${borderRadius.small} text-white mx-[0.5%] pb-0.3 cursor-pointer ${fontsSize.m}`}>
                        Remove Item
                    </div>
                    <div
                        className={`w-[48%] h-[48%] ${plainColors.lightBlue} flex justify-center items-center ${borderRadius.small} text-white mx-[0.5%] pb-0.3 cursor-pointer ${fontsSize.m}`}>
                        Split bill
                    </div>
                    <div onClick={increaseSelectedQuantity}
                         className={`w-[23.5%] h-[48%] ${plainColors.success} flex justify-center items-center ${borderRadius.small} text-white mx-[0.5%] cursor-pointer ${fontsSize.m}`}>
                        <b className={'text-[4vh] mb-[1vh]'}>+</b>
                    </div>
                    <div onClick={decreaseSelectedQuantity}
                         className={`w-[23.5%] h-[48%] ${plainColors.danger} flex justify-center items-center ${borderRadius.small} text-white mx-[0.5%] cursor-pointer ${fontsSize.m}`}>
                        <b className={'text-[4vh] mb-[1vh]'}>-</b>
                    </div>

                    <div
                        className={`w-[48.5%] h-[40%] flex justify-end items-center ${borderRadius.small} text-white flex-col`}>
                        <div
                            className={`h-auto w-[100%] flex items-center justify-end ${borderRadius.small} px-[1.5vh] ${fontsSize.l} font-bold text-gray-700 max-lg:text-[1.5vh]`}>{(orderedSum).toLocaleString()}&nbsp;
                            <b className={`${fontsSize.m} max-lg:text-[1.5vh]`}> den</b>
                        </div>
                        <div
                            className={`h-auto w-[100%] font-medium text-red-300 flex items-center justify-between ${borderRadius.small} px-[1.5vh] ${fontsSize.m} max-lg:text-[1.5vh]`}>
                            <div>To add</div>
                            +
                            {(toAddSum).toLocaleString()} den
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderSideBar;
